export default __webpack_public_path__ + "static/fbk-a792e2d4efcca0bfdc15a96c59921974.svg";